import firebase from '../Firestore'

function SignOut()
{
    return(firebase.auth().signOut().then(() => {
    }))
}

export default SignOut